import * as _ from 'lodash';
import * as Vega3 from '../../../util/vega3';
import * as ServerApi from './serverApi';
import * as File from '../files';

export const DB = {
  projects: [
    {
      id: 0,
      entityName: 'shawn',
      name: 'fasion-sweep',
      createdAt: '2019-03-01T02:44:20',
      stars: 14,
    },
    {
      id: 1,
      entityName: 'shawn',
      name: 'dsviz_demo',
      createdAt: '2020-01-01T02:44:20',
      stars: 5,
    },
  ],
  orgs: [
    {
      id: 0,
      name: 'wandb',
      createdAt: 'jan 1, 2020',
      stars: 14,
    },
  ],
  users: [
    {
      id: 0,
      username: 'shawn',
      orgId: 0,
    },
  ],
  runs: [
    {
      id: 0,
      projectId: 0,
      userId: 0,
      displayName: 'george',
      createdAt: 'jan 1, 2020',
      stars: 8,
      summary: {
        x: 100,
        y: 101,
      } as {[key: string]: number},
    },
    {
      id: 1,
      projectId: 0,
      displayName: 'frank',
      createdAt: 'jan 2, 2020',
      stars: 7,
      summary: {
        x: -10.2,
        y: -1000,
      } as {[key: string]: number},
    },
    {
      id: 2,
      projectId: 1,
      userId: 0,
      displayName: 'sally',
      createdAt: 'jan 3, 2020',
      stars: 5,
      summary: {
        x: 10.1,
        y: 6,
      } as {[key: string]: number},
    },
    {
      id: 3,
      projectId: 1,
      displayName: 'bob',
      createdAt: 'nov 8, 2019',
      stars: 1,
      summary: {
        x: 5,
        y: 6.1,
      } as {[key: string]: number},
    },
  ],
  artifactTypes: [
    {
      id: 0,
      projectId: 1,
      name: 'dataset',
    },
  ],
  artifactVersions: [
    {
      id: 0,
      projectId: 1,
      artifactTypeId: 0,
      artifactID: 'train_results:v3',
      outputByRunId: 1,
      inputToRunIds: [2],
      createdAt: 'jan 9, 2020',
      stars: 2,
      size: 1921,
    },
    {
      id: 1,
      projectId: 1,
      outputByRunId: 1,
      artifactTypeId: 0,
      artifactID: 'train_results:v2',
      inputToRunIds: [3],
      createdAt: 'jan 8, 2020',
      stars: 5,
      size: 1921,
    },
  ],
};

const FILES: {
  [artifactId: string]: undefined | {[path: string]: string | undefined};
} = {
  0: {
    'raw_examples.table.json': JSON.stringify({
      columns: ['a', 'b', 'x', 'j'],
      data: [
        [14, -2, 'dog', 'j1'],
        [1, 21, 'dog', 'j2'],
        [9, 24, 'roar', 'j3'],
      ],
    }),
    'train_iou_score_table.table.json': JSON.stringify({
      columns: ['a', 'b', 'x'],
      data: [
        [14, -1, 'cat'],
        [14, -1, 'cat'],
        [14, -2, 'dog'],
        [1, 2, 'dog'],
        [9, 2, 'dog'],
      ],
    }),
    'train-results.joined-table.json': JSON.stringify({
      _type: 'joined-table',
      join_key: 'a',
      table1: 'train_iou_score_table.table.json',
      table2: 'raw_examples.table.json',
    }),
    'part_table.partitioned-table.json': JSON.stringify({
      _type: 'partitioned-table',
      parts_path: 'parts',
    }),
    'parts/t1.table.json': JSON.stringify({
      columns: ['a', 'b', 'c'],
      data: [
        [1, 'a', true],
        [2, 'b', false],
        [3, 'c', true],
      ],
    }),
    'parts/t2.table.json': JSON.stringify({
      columns: ['a', 'b', 'c'],
      data: [
        [4, 'd', true],
        [5, 'e', false],
        [6, 'f', true],
      ],
    }),
    'parts/t3.table.json': JSON.stringify({
      columns: ['a', 'b', 'c'],
      data: [
        [7, 'g', true],
        [8, 'h', false],
        [9, 'i', true],
      ],
    }),
  },
};

const FILE_METADATA: {
  [artifactId: string]: {[path: string]: File.MetadataNode};
} = {
  0: {
    'train_iou_score_table.table.json': {
      type: 'file',
      fullPath: 'train_iou_score_table.table.json',
      url: 'url:artifact0_TEST',
      size: 45,
    },
    'part_table.partitioned-table.json': {
      type: 'file',
      fullPath: 'part_table.partitioned-table.json',
      url: 'url:artifact0_TEST',
      size: 45,
    },
    parts: {
      type: 'dir',
      fullPath: 'parts',
      size: 99,
      dirs: {},
      files: {
        't1.table.json': {
          type: 'file',
          fullPath: 'parts/t1.table.json',
          url: 'url:artifact0_TEST',
          size: 99,
        },
        't2.table.json': {
          type: 'file',
          fullPath: 'parts/t2.table.json',
          url: 'url:artifact0_TEST',
          size: 99,
        },

        't3.table.json': {
          type: 'file',
          fullPath: 'parts/t3.table.json',
          url: 'url:artifact0_TEST',
          size: 99,
        },
      },
    },
  },
  1: {
    'train_iou_score_table.table.json': {
      type: 'file',
      fullPath: 'train_iou_score_table.table.json',
      url: 'url:artifact1_TEST',
      size: 99,
    },
  },
};

function resolveRootProject(field: Vega3.QueryField) {
  const entityNameArg = field.args?.find(a => a.name === 'entityName')?.value;
  const projectNameArg = field.args?.find(a => a.name === 'name')?.value;
  const project = DB.projects.find(
    p => p.entityName === entityNameArg && p.name === projectNameArg
  );
  if (project == null) {
    return {project: null};
  }

  const resultFields: {[key: string]: any} = {};
  for (const childField of field.fields) {
    if (childField.name === 'id') {
      resultFields[childField.alias ?? childField.name] = project.id;
    } else if (childField.name === 'createdAt') {
      resultFields[childField.alias ?? childField.name] = project.createdAt;
    } else if (childField.name === 'name') {
      resultFields[childField.alias ?? childField.name] = project.name;
    } else if (childField.name === 'stars') {
      resultFields[childField.alias ?? childField.name] = project.stars;
    } else if (childField.name === 'runs') {
      resultFields[childField.alias ?? childField.name] = {
        // Get edges.node field
        // TODO: This isn't really right. Doesn't handle asking for other fields
        //   on edges
        edges: resolveProjectRuns(
          project,
          childField,
          childField.fields[0].fields[0]
        ),
      };
    } else if (childField.name === 'artifactType') {
      resultFields[
        childField.alias ?? childField.name
      ] = resolveProjectArtifactType(project, childField);
    } else {
      throw new Error('invalid');
    }
  }
  return {project: resultFields};
}

function resolveRootOrg(field: Vega3.QueryField) {
  const orgNameArg = field.args?.find(a => a.name === 'name')?.value;
  const org = DB.orgs.find(o => o.name === orgNameArg);
  if (org == null) {
    return {org: null};
  }

  const resultFields: {[key: string]: any} = {};
  for (const childField of field.fields) {
    if (childField.name === 'id') {
      resultFields[childField.alias ?? childField.name] = org.id;
    } else if (childField.name === 'members') {
      resultFields[childField.alias ?? childField.name] = resolveOrgMembers(
        org,
        childField
      );
    } else {
      throw new Error('invalid');
    }
  }
  return {org: resultFields};
}

function resolveOrgMembers(
  org: typeof DB.orgs[number],
  field: Vega3.QueryField
) {
  const members = DB.users.filter(u => u.orgId === org.id);
  return members.map(member => {
    const resultFields: {[key: string]: any} = {};
    for (const childField of field.fields) {
      if (childField.name === 'id') {
        resultFields[childField.alias ?? childField.name] = member.id;
      } else if (childField.name === 'username') {
        resultFields[childField.alias ?? childField.name] = member.username;
      } else if (childField.name === 'runs') {
        resultFields[childField.alias ?? childField.name] = resolveUserRuns(
          member,
          childField
        );
      } else {
        throw new Error('invalid');
      }
    }
    return resultFields;
  });
}

function resolveUserRuns(
  user: typeof DB.users[number],
  field: Vega3.QueryField
) {
  const runs = DB.runs.filter(r => r.userId === user.id);
  return runs.map(run => {
    // Note: duplicated from resolveProjectRuns
    const resultFields: {[key: string]: any} = {};
    for (const childField of field.fields) {
      if (childField.name === 'id') {
        resultFields[childField.alias ?? childField.name] = run.id;
      } else if (childField.name === 'stars') {
        resultFields[childField.alias ?? childField.name] = run.stars;
      } else {
        throw new Error('invalid');
      }
    }
    return resultFields;
  });
}

function resolveProjectRuns(
  project: typeof DB.projects[number],
  runsField: Vega3.QueryField,
  nodeField: Vega3.QueryField
) {
  let runs = DB.runs.filter(r => r.projectId === project.id);
  const runsFilterArg = runsField.args?.find(a => a.name === 'filter')?.value;
  if (runsFilterArg != null) {
    runs = _.filter(runs, runsFilterArg);
  }
  return runs.map(run => {
    const resultFields: {[key: string]: any} = {};
    for (const childField of nodeField.fields) {
      if (childField.name === 'id') {
        resultFields[childField.alias ?? childField.name] = run.id;
      } else if (childField.name === 'displayName') {
        resultFields[childField.alias ?? childField.name] = run.displayName;
      } else if (childField.name === 'summaryMetrics') {
        const keys = childField.args?.find(a => a.name === 'keys')?.value ?? [];
        const key0 = keys[0];
        if (key0 == null) {
          throw new Error('invalid');
        }
        resultFields[childField.alias ?? childField.name] = JSON.stringify({
          [key0]: run.summary[key0],
        });
      } else if (childField.name === 'stars') {
        resultFields[childField.alias ?? childField.name] = run.stars;
      } else {
        throw new Error('invalid childField: ' + childField.name);
      }
    }
    return {node: resultFields};
  });
}

function resolveProjectArtifactType(
  project: typeof DB.projects[number],
  artifactTypeField: Vega3.QueryField
) {
  const nameArg = artifactTypeField.args?.find(a => a.name === 'name')?.value;
  const artifactType = DB.artifactTypes.find(
    at => at.projectId === project.id && at.name === nameArg
  );
  if (artifactType == null) {
    return undefined;
  }
  const resultFields: {[key: string]: any} = {};
  for (const childField of artifactTypeField.fields) {
    if (childField.name === 'id') {
      resultFields[childField.alias ?? childField.name] = artifactType.id;
    } else if (childField.name === 'artifact') {
      resultFields[
        childField.alias ?? childField.name
      ] = resolveArtifactTypeArtifact(artifactType, childField);
    } else {
      throw new Error(
        'invalid childField for projectArtifactType: ' + childField.name
      );
    }
  }
  return resultFields;
}

function resolveArtifactTypeArtifact(
  artifactType: typeof DB.artifactTypes[number],
  artifactTypeField: Vega3.QueryField
) {
  const artifactNameArg = artifactTypeField.args?.find(a => a.name === 'name')
    ?.value;
  const artifactVersion = DB.artifactVersions.find(
    av =>
      av.artifactTypeId === artifactType.id && av.artifactID === artifactNameArg
  );
  if (artifactVersion == null) {
    return undefined;
  }
  const resultFields: {[key: string]: any} = {};
  for (const childField of artifactTypeField.fields) {
    if (childField.name === 'id') {
      resultFields[childField.alias ?? childField.name] = artifactVersion.id;
    } else if (childField.name === 'size') {
      resultFields[childField.alias ?? childField.name] = artifactVersion.size;
    } else {
      throw new Error(
        'invalid childField for artifactTypeArtifact: ' + childField.name
      );
    }
  }
  return resultFields;
}

export class Client implements ServerApi.ServerAPI {
  async execute(query: Vega3.Query): Promise<any> {
    // console.log('EXECUTING QUERY', query);
    if (query.queryFields.length !== 1) {
      throw new Error('invalid');
    }
    const qf0 = query.queryFields[0];
    if (qf0.name === 'project') {
      return new Promise(resolve => {
        // Delay for testing
        // TODO: Unnecessary
        setTimeout(() => {
          resolve(resolveRootProject(qf0));
        }, 1);
      });
    } else if (qf0.name === 'org') {
      return new Promise(resolve => {
        // Delay for testing
        // TODO: Unnecessary
        setTimeout(() => {
          resolve(resolveRootOrg(qf0));
        }, 1);
      });
    } else if (qf0.name === 'runs') {
      const projectIdArg = qf0.args?.find(a => a.name === 'projectId')?.value;
      return new Promise(resolve => {
        // Delay for testing
        // TODO: Unnecessary
        setTimeout(() => {
          const runs = DB.runs.filter(r => r.projectId === projectIdArg);
          resolve(runs);
        }, 1);
      });
    } else if (qf0.name === 'artifacts') {
      const projectIdArg = qf0.args?.find(a => a.name === 'projectId')?.value;
      return new Promise(resolve => {
        // Delay for testing
        // TODO: Unnecessary
        setTimeout(() => {
          const avs = DB.artifactVersions.filter(
            r => r.projectId === projectIdArg
          );
          resolve(avs);
        }, 1);
      });
    } else if (qf0.name === 'artifacts-createdBy') {
      const artifactIds = qf0.args?.find(a => a.name === 'artifactIds')?.value;
      return new Promise(resolve => {
        // Delay for testing
        // TODO: Unnecessary
        setTimeout(() => {
          const runIds = DB.artifactVersions
            .filter(av => artifactIds.includes(av.id))
            .map(a => a.outputByRunId);
          const runs = runIds.map(rid => DB.runs.find(r => r.id === rid));
          resolve(runs);
        }, 1);
      });
    }
    throw new Error('invalid');
  }

  getFileContents(
    artifactId: string,
    assetPath: string
  ): ReturnType<typeof File.cachedLoadArtifactFileContent> {
    return new Promise(resolve => {
      // Delay for testing
      // TODO: Unnecessary
      setTimeout(() => {
        const contents = FILES?.[artifactId]?.[assetPath] ?? null;
        resolve({refFileId: null, contents});
      }, 1);
    });
  }

  getFileDirectUrl(
    artifactId: string,
    assetPath: string
  ): ReturnType<typeof File.loadArtifactFileDirectUrl> {
    return new Promise(resolve => {
      // Delay for testing
      // TODO: Unnecessary
      setTimeout(() => {
        // TODO: not actually loading something
        resolve({refFileId: null, directUrl: ''});
      }, 1);
    });
  }

  // TODO: NOT DONE
  getFileMetadata(
    artifactId: string,
    assetPath: string
  ): ReturnType<typeof File.loadArtifactFilePathMetadata> {
    return new Promise(resolve => {
      // Delay for testing
      // TODO: Unnecessary
      setTimeout(() => {
        resolve(FILE_METADATA?.[artifactId]?.[assetPath] ?? null);
        // const contents = FILES?.[artifactId]?.[assetPath] ?? null;
        // resolve({refFileId: null, contents});
      }, 1);
    });
  }
}
